export default __webpack_public_path__ + "static/media/water-filled.a66bacd8.svg";